import { Hero } from "../components/home/Hero";
import {
  AboutSection,
  DisciplinesSection,
  ArenasSection,
  FederationsSection,
  ExperienceSections,
  PartnersSection,
  NewsSection,
  FinalCTA,
} from "../components/home/Sections";
import { Marquee } from "../components/shared/Marquee";
import { DISCIPLINES } from "../data/content";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee items={DISCIPLINES.map((d) => d.name)} />
      <AboutSection />
      <DisciplinesSection />
      <ArenasSection />
      <FederationsSection />
      <ExperienceSections />
      <PartnersSection />
      <NewsSection />
      <FinalCTA />
    </>
  );
}
